import { useShowHeaderTray } from 'Shared/articles/hooks/useShowHeaderTray';

import { useIsAudioAvailable } from './useIsAudioAvailable';

import type { FullArticleT } from 'Shared/types/ApiModels';
import type { ArticleTypeT } from 'Constants/articleTypes';
import type { ServicePlanArticleT } from 'Services/api/types';

export const useShowHeaderPlayButton = (
  article?: FullArticleT | ServicePlanArticleT,
  articleType?: ArticleTypeT,
  mpServicePlanId?: string,
) => {
  const showHeaderTray = useShowHeaderTray(articleType ?? null);
  const isAudioAvailable = useIsAudioAvailable(
    article?.audioDuration ?? null,
    articleType,
  );

  return isAudioAvailable && (showHeaderTray || mpServicePlanId);
};
